<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row align="center">
        <v-col class="text-right">
          <a href="/promocode">Назад</a>

        </v-col>
      </v-row>
      <v-data-table
          no-data-text="Нет заказов"
          no-results-text="По заданному запросу ничего не найдено"
          :items="orders"
          :headers="headers"
          :loading="loading"
          :options.sync="options"
          :footer-props="footerProps"

          :items-per-page="-1"
          :hide-default-footer="false"
          loading-text="Загрузка заказов... Подождите пожалуйста"
      >
      </v-data-table>
      <!--</v-card>-->
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src

import PromocodeService from '../../api/PromocodeService'

export default {
  name: 'ProductOrders',
  components: {},
  props: {
    id: {
      default: null,
    }
  },
  data: () => ({
    loading: true,
    orders: [],
    options: {},
    footerProps: {
      itemsPerPageText: 'Промокодов на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [-1]
    },
    headers: [
      {
        text: '№ Заказа',
        value: 'id',
        sortable: false
      },
      {
        text: '№ Телефона',
        value: 'phone',
        sortable: false
      },
      {
        text: 'Сумма Заказа',
        value: 'sum',
        sortable: false
      },
    ],
  }),
  mounted() {
    PromocodeService.listByPromo(this.id).then(res => {
      const orders = res.data;

      orders.push({
        id: '',
        phone: 'Количество: ' + orders.length,
        sum: 'Итого: ' + orders.reduce((acc, item) => acc + item.sum, 0),
      });

      this.orders = orders;
      this.loading = false;
    }).catch(console.error);
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style>
.changed-row {
  background-color: #FFEEEC;
}
</style>

<style lang="scss" scoped>
.v-btn--fab.v-size--x-small {
  width: 20px;
  height: 20px;

  .mdi::before {
    font-size: 12px;
  }
}

span.v-btn {
  border-color: currentColor !important;
}

.filter-popup {
  position: absolute;
  width: 250px;
  z-index: 5;

  &:hover {
    cursor: auto;
  }


  &.v-card--link:focus::before {
    opacity: 0;
  }
}
</style>
